import React from 'react';
import { Button } from './Button';

export interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
  isRetrying?: boolean;
  /** Optional secondary CTA (e.g. open Settings). */
  actionLabel?: string;
  onAction?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'No se pudieron cargar los datos',
  message = 'Hubo un problema al conectar con el servicio. Puedes intentar nuevamente.',
  onRetry,
  retryLabel = 'Reintentar conexión',
  isRetrying = false,
  actionLabel,
  onAction,
}) => {
  return (
    <div
      className="z-error-state"
      role="alert"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '28px 18px',
        borderRadius: 18,
        background: 'var(--z-bad-bg)',
        border: 'none',
        textAlign: 'center',
        gap: 12,
        margin: '12px 0',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          background: 'rgba(239, 68, 68, 0.2)',
          color: 'var(--z-bad)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
          fontWeight: 700,
        }}
      >
        !
      </span>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          maxWidth: 420,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <span
          style={{
            fontSize: 14.5,
            fontWeight: 700,
            color: 'var(--z-bad-ink, var(--z-bad))',
            overflowWrap: 'anywhere',
          }}
        >
          {title}
        </span>
        <span
          style={{
            fontSize: 12.5,
            color: 'var(--z-dim)',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          }}
        >
          {message}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
        {onAction && actionLabel ? (
          <Button
            variant="primary"
            size="sm"
            data-testid="error-state-action"
            onClick={onAction}
            style={{ marginTop: 4 }}
          >
            {actionLabel}
          </Button>
        ) : null}
        {onRetry ? (
          <Button
            variant="soft"
            size="sm"
            onClick={onRetry}
            disabled={isRetrying}
            style={{ marginTop: 4 }}
          >
            {isRetrying ? 'Reintentando…' : retryLabel}
          </Button>
        ) : null}
      </div>
    </div>
  );
};
